// APIs
import * as rentalCarsAPI from "src/apis/rental-cars/cars.api";

// Helpers
import { AxiosCustomResponse } from "src/helpers/axios.helper";

export const fetchSpecialDeals = async (): Promise<
    AxiosCustomResponse<Car[]>
> => {
    const { payload, success } = await rentalCarsAPI.fetchSpecialDeals();

    const result = payload?.map<Car>(
        ({
            car_specs_id: id,
            brand,
            model,
            image_url: imageUrl,
            size,
            transmission_gearbox: gear,
            truck,
            number_of_doors: numberOfDoors,
            number_of_seats: numberOfSeats,
            offers: { special_deal: price },
        }) => ({
            id,
            brand,
            model,
            imageUrl,
            size,
            gear,
            truck,
            numberOfDoors,
            numberOfSeats,
            price: parseInt(price),
        })
    );
    return { payload: result, success };
};
